import React from "react";
import styles from "./styles/suggestion-block.module.scss";

type SuggestionBlockProps = {
  text: string;
  onClick: (text: string) => void;
};

const SuggestionBlock = ({ text, onClick }: SuggestionBlockProps) => {
  const handleClick = () => {
    onClick(text);
  };

  return (
    <div className={styles.wrapper} onClick={handleClick}>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default SuggestionBlock;
